<!-- Header  -->
<div class="subheader with-padding flgrow">
  <div class="row align-items-center">

    <!-- Multiselect Dealer Dropdown -->
    <div class="col-lg-3 col-md-3 col-sm-6">
      <div class="input-group">
        <ng-multiselect-dropdown style="width: 100%" [settings]="dropdownSettings" [data]="dealerList"
          placeholder="{{ 'lblSearchDealer' | translate }}" [(ngModel)]="selectedDealers"
          (ngModelChange)="onChangeDealer($event)">
        </ng-multiselect-dropdown>
      </div>
    </div>

    <!-- Date Range Picker -->
    <div class="col-lg-3 col-md-3 col-sm-6">
      <div class="date">
        <input bsDaterangepicker name="BookedDate" [bsConfig]="myDateRangePickerOptions" class="form-control" 
        [(ngModel)]="selectedDate" (ngModelChange)="onDateRangeChanged($event)"/>
      </div>
    </div>

    <!-- Clear Button -->
    <button type="submit" (click)="onClearFilter()" class="btn btn-primary btn-md"
      ngbTooltip="{{ 'lblClearFilters' | translate }}" placement="bottom" aria-label="Center Align">
      <em class="far fa-times-circle font16 align-top"></em>
    </button>
    <a class="ml-3 btn btn-outline-primary" href="javascript:void(0);" (click)="onRefreshClick()"
      aria-label="Center Align">
      <em class="fas fa-sync fa-lg"></em>
    </a>

    <div class="pl-2  align-items-center flex-sm-row flex-column justify-content-end ml-auto">
      <!-- Excel -->
      <button type="button" (click)="exportAsXLSX()" ngbTooltip="{{'lblExportExcel' | translate}}" placement="bottom"
        aria-label="Center Align" style="margin-right: 10px;">
        <img src="./../../../assets/images/excel.png" height="32" width="32" alt="" />
      </button>
      <!-- PDF -->
      <button class="btn btn-link icon-pdf" type="button" (click)="exportAsPDF()"
        ngbTooltip="{{'lblExportPDF' | translate}}" placement="left" aria-label="Center Align">
        <em class="far fa-file fa-2x"></em>
        <span class="bdg">PDF</span>
      </button>
    </div>
  </div>
</div>

<!-- Body -->
<div class="container prel">
  <div class="row">
    <div class="c12">
      <div class="card mb-3">
        <!-- Body Header -->
        <div class="card-header d-flex justify-content-between" translate>
          lblTowedInReport
          <div class="font16 fontbold">
            <span class="font16 fontnormal" translate>lblTotal</span>:&nbsp;
            {{ totalCount }}
            &nbsp;<span class="font16 fontnormal" translate>lblResults</span>
          </div>
        </div>
        <!-- Body Content -->
        <div class="table-responsive max-h254" infinite-scroll [infiniteScrollDistance]="scrollDistance"
          [infiniteScrollThrottle]="throttle" [scrollWindow]="false" (scrolled)="onScrollDown()">
          <table class="tablest1">
            <thead>
              <tr>
                <th style="width: 55px" scope="col">#</th>
                <th scope="col" style="width: 25%" translate>lblDealerName</th>
                <th scope="col" style="width: 20%" sortable="totalAppointments" (sort)="onSort($event)"
                  class="text-right" translate>
                  lblAppointments
                </th>
                <th scope="col" style="width: 20%" sortable="towInCount" (sort)="onSort($event)" class="text-right"
                  translate>
                  lblTowedInOrders
                </th>
                <th scope="col" style="width: 20%" sortable="towInPercentage" (sort)="onSort($event)" class="text-right"
                  translate>
                  lblTowInPercentage
                </th>
                <th scope="col" class="text-center" translate>lblAction</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="toweInUsageList?.length > 0; else load_NotFound_Template">
                <tr *ngFor="let item of toweInUsageList; let i = index">
                  <td>{{ i + 1 }}</td>
                  <td>
                    <ngb-highlight [result]="item.dealerName"> </ngb-highlight>
                  </td>
                  <td class="text-right">

                    <div style="margin-right: 40px">
                      <ngb-highlight [result]="item.totalAppointments">
                      </ngb-highlight>
                    </div>
                  </td>
                  <td class="text-right">
                    <div style="margin-right: 40px">
                      <ngb-highlight [result]="item.towInCount">
                      </ngb-highlight>
                    </div>
                  </td>
                  <td class="text-right">
                    <div style="margin-right: 40px">
                      <ngb-highlight [result]="item.towInPercentage">
                      </ngb-highlight>
                      %
                    </div>
                  </td>
                  <td class="nowrap text-center">
                    <a class="btn btn-view" ngbTooltip="{{ 'lblViewTowedInAppointments' | translate }}"
                      tooltipClass="custom-revert" (click)="onView(item)">
                      <em class="fa fa-eye fa-lg"></em>
                    </a>
                  </td>
                </tr>
              </ng-container>
              <ng-template #load_NotFound_Template>
                <tr>
                  <td colspan="8" class="no-record" translate>
                    lblNoRecordsFound
                  </td>
                </tr>
              </ng-template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>